import * as React from 'react'
import { ProcessSlot } from '../../../../api/process'
import Avatar from '../../../../components/ui/Avatar'
import Button from '../../../../components/ui/Button'
import { SlotId, UserId } from '../..'

interface SlotInfoProps {
  slot: ProcessSlot
  slots: Map<SlotId, UserId>
  onAssignUser: (slot: ProcessSlot) => void
  onUnassignUser: (slot: ProcessSlot) => void
}

const SlotInfo = ({ slot, slots, onAssignUser, onUnassignUser }: SlotInfoProps) => {
  const onClickAssign = () => {
    onAssignUser(slot)
  }

  const onClickUnassign = () => {
    onUnassignUser(slot)
  }

  return (
    <div className="configure-slots__slot">
      <div className="configure-slots__info">
        <span className="configure-slots__name">{slot.name}</span>
        {
          slots.has(slot.id) ?
            <Avatar
              size="small"
              user={slots.get(slot.id)}
              withName={true}
            />
            : null
        }
      </div>
      {
        slots.has(slot.id) ?
          <Button l10nId="begin-process-unassign-user" clickHandler={onClickUnassign}>
            Unassign user
          </Button>
          :
          <Button l10nId="begin-process-assign-user" clickHandler={onClickAssign}>
            Select user
          </Button>
      }
    </div>
  )
}

export default SlotInfo
